import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const ProjectsReducer = CreateGenericReducer(constructs.project);
